import { FC } from 'react';

import styled from '@emotion/styled';

import { Button } from '@britishcouncil/react-solas';
import { Modal } from '@britishcouncil/react-solas-ors3';

export const UciInformationModal: FC<{ show: boolean; onExit: () => void }> = ({ show, onExit }) => {
  return (
    <Modal
      show={show}
      title="Unique Candidate Identifier (UCI) number"
      onExit={onExit}
      footer={
        <Footer>
          <Button intent="primary" onClick={onExit}>
            Ok
          </Button>
        </Footer>
      }
    >
      <Container>
        <p>
          A Unique Candidate Identifier (UCI) is a reference which consists of 13 characters and would have been used in
          your previous exam sittings.
        </p>
        <p>You must have one UCI across all of your registrations to gain an overall result.</p>
        <p>
          In case you have more than one UCI number then please contact your Exams centre immediately to merge these. By
          having more than one UCI number, you will be disadvantaged as you will have scattered marks and will not be
          able to apply for cash - ins. It is your responsibility to ensure that the UCI number is added correctly for
          this registration.
        </p>
      </Container>
    </Modal>
  );
};

const Footer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

const Container = styled.div`
  max-width: 632px;
`;
